module.exports = __webpack_public_path__ + "img/chatIcon.1cb5f0af.png";